/**
 * @desc 来源系统下拉
 */
const URL = "/rantion-crawler";
import http, { updateResponse } from "@/http";
export function request(options?: any) {
  return updateResponse(
    http(URL + `/crawler/getSourceSystem`, {
      method: "POST",

      ...options,
    }),
  );
}
